var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button',_vm._b({directives:[{name:"rw",rawName:"v-rw"}],attrs:{"loading":_vm.loading,"ghost":""},on:{"on-click":_vm.onClick}},'n-button',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }